import {PODictionary} from "../typescript/Types";

export const INSTANCE_TYPE_TO_QUERY_LANGUAGE: PODictionary = {
    'oracle': 'plsql',
    'mysql': 'mysql',
    'cockroachdb': 'tsql',
    'db2': 'tsql',
    'sqlserver': 'tsql'
}